import { isAiOnlyWfsDefectRow } from '@/features/defect-drawer/utils/defectFilter';

/**
 * 확정 결함 WFS 재로드 시 store 에 있던 AI 행을 유지한다.
 * (전체 setWfsDefectRows 교체로 AI 목록이 사라지는 레이스 방지)
 */
export function mergeConfirmedWfsRowsWithExistingAi(confirmedRows, existingRows) {
  const confirmed = Array.isArray(confirmedRows) ? confirmedRows : [];
  const prevAi = (existingRows || []).filter(isAiOnlyWfsDefectRow);
  if (!prevAi.length) {
    return confirmed;
  }

  const merged = [...confirmed];
  const seqs = new Set(merged.map(r => Number(r.seq)));

  for (const ai of prevAi) {
    const key = Number(ai.seq);
    if (!Number.isFinite(key) || seqs.has(key)) {
      continue;
    }
    merged.push(ai);
    seqs.add(key);
  }

  merged.sort((a, b) => (a.seq ?? 0) - (b.seq ?? 0));
  return merged;
}
